import React from 'react';
import { moneyFormat } from 'helpers/moneyFormat';
import { RankingItem } from './dashboardMetrics';
import {
  EmptyState,
  RankingBar,
  RankingCount,
  RankingItemRow,
  RankingLabel,
  RankingTrack,
  RankingValue,
} from './ExecutiveDashboardStyles';

export function renderRanking(items: RankingItem[], emptyMessage: string, showValues: boolean, maximumAmount: number) {
  if (!items.length) {
    return <EmptyState>{emptyMessage}</EmptyState>;
  }

  return items.map(item => (
    <RankingItemRow key={item.label}>
      <RankingLabel title={item.label}>{item.label}</RankingLabel>
      <RankingValue>{item.amount ? (showValues ? moneyFormat(item.amount) : '••••') : 'R$ 0,00'}</RankingValue>
      <RankingTrack>
        <RankingBar style={{ width: `${Math.max(((item.amount || 0) / maximumAmount) * 100, 2)}%` }} />
      </RankingTrack>
      <RankingCount>{showValues ? item.value : '••••'}</RankingCount>
    </RankingItemRow>
  ));
}
